import {Service} from "@/apiServices/Service";

export class PromocionesService extends Service {
    constructor() {
        super('promocion/');
    }
    obtenerListaPromociones(filtro){
        return this.http.post(this.getUrl(['obtener']),filtro)
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerPorId(id){
        return this.http.get(this.getUrl(['obtenerId'],'?id='+id))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    suspenderPromocion(id){
        return this.http.put(this.getUrl(['suspender'],'?idPromocion='+id))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    guardarPromocion(datos){
        return this.http.post(this.getUrl(['guardar']),datos)
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerPromocionesPorPx(idClinica, idSesion) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener', 'promocionesPaciente']),
            {idClinica: idClinica, idSesion: idSesion})
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                console.error(e)
                /*this.onError(e);*/
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerPromocionesPorPxPorTx(idClinica, idSesion, idTratamiento) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener', 'promocionesPacienteV2']),
            {idClinica: idClinica, idSesion: idSesion, idTratamiento: idTratamiento})
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                console.error(e)
                /*this.onError(e);*/
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerPromocionesPorPtiParaSDI(datos) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener', 'promocionesPacienteSDI', 'porFecha']), datos)
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                console.error(e)
                /*this.onError(e);*/
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}
